import { toast } from "react-toastify";
/**
 * inverse of isEmpty function
 * @param value
 * @returns {boolean}
 */
export function notEmpty(value) {
    return !isEmpty(value);
}

/**
 * check variable for empty value
 * @param value
 * @returns {boolean}
 */
export function isEmpty(value) {
    if (value === undefined) return true;

    if (
        typeof value === "function" ||
        typeof value === "number" ||
        typeof value === "boolean" ||
        Object.prototype.toString.call(value) === "[object Date]"
    )
        return false;

    if (value === null || value === "" || value.length === 0)
        // null or 0 length array
        return true;

    if (typeof value === "object") {
        // empty object

        let r = true;

        if (Object.keys(value).length > 0) {
            r = false;
        }

        return r;
    }

    return false;
}

/**
 * alias of compareString function
 * @param str1
 * @param str2
 */
export function cmpStr(str1, str2) {
    return this.compareString(str1, str2);
}

/**
 * alias of compareBoolean function
 * @param value1
 * @param value2
 */
export function cmpBool(value1, value2) {
    return this.compareBoolean(value1, value2);
}

/**
 * alias of compareString function
 * @param value1
 * @param value2
 */
export function cmpInt(value1, value2) {
    return this.compareInt(value1, value2);
}

/** Toast Notification */

export function alert(type, { message = "", position = "top-center" }) {
    toast[type](message, {
        position,
    });
}

/**
 * compare two booleans and returns true if match else false
 * @param value1
 * @param value2
 * @returns {boolean}
 */
export function compareBoolean(value1, value2) {
    if (
        typeof value1 !== typeof undefined &&
        typeof value1 !== typeof undefined
    ) {
        if (Boolean(value1) === Boolean(value2)) {
            return true;
        }
    }
    return false;
}

/**
 * compare two values and returns true if match else false
 * @param str1
 * @param str2
 */
export function compareString(str1, str2) {
    if (typeof str1 !== typeof undefined && typeof str2 !== typeof undefined) {
        if (String(str1).toLowerCase() === String(str2).toLowerCase()) {
            return true;
        }
    }
    return false;
}

/**
 * round number to two decimal
 * @param num
 */
export function roundToTwo(num) {
    // Round to 2 decimal places using toFixed
    const rounded = num.toFixed(2);

    // Check if the decimal part is ".00" (exactly two zeros)
    if (/\.00$/.test(rounded)) {
        // Remove the decimal and trailing zeros
        return parseFloat(rounded.slice(0, -3));
    }

    // Otherwise, return the rounded string
    return rounded;
}

/**
 * format number with comma
 * @param x
 */
export function toComma(x) {
    return roundToTwo(x)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

/**
 * Validate email
 * @param email
 */
export function validateEmail(email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
}

/**
 * Returns number of token per kg
 * @param kg
 */
export function tokenCalculationPerKg(kg) {
    return toComma(kg * 10);
}
